module.exports = __webpack_public_path__ + "img/ic_profile_gem@2x.064ef347.png";